/**
 * AssetAssignmentTypeService
 * Service for AssetAssignmentType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetAssignmentType CRUD operations */
export class AssetAssignmentTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetAssignmentTypeService.DEFAULT_SERVICE_PATH,
            basePath: AssetAssignmentTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetAssignmentTypeService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetAssignmentTypeService.BASE_PATH = 'api/asset-assignment-types';
//# sourceMappingURL=AssetAssignmentTypeService.js.map